import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import IndexPage from 'flarum/forum/components/IndexPage';
import Button from 'flarum/common/components/Button';
app.initializers.add('flarum-pusher', () => {
  const forumAttr = key => {
    var _app$forum$attribute, _app$forum, _app$data, _app$data$find;
    return (_app$forum$attribute = (_app$forum = app.forum) == null ? void 0 : _app$forum.attribute(key)) != null ? _app$forum$attribute : (_app$data = app.data) == null || (_app$data = _app$data.resources) == null || (_app$data$find = _app$data.find) == null || (_app$data$find = _app$data$find.call(_app$data, r => r.type === 'forums')) == null || (_app$data$find = _app$data$find.attributes) == null ? void 0 : _app$data$find[key];
  };
  const pusherKey = forumAttr('pusherKey');
  if (!pusherKey) {
    return;
  }
  app.pusher = (async () => {
    try {
      var _app$session, _app$data2, _app$data3, _app$session2;
      // @ts-expect-error
      await import('https://cdn.jsdelivr.net/npm/pusher-js@7.0.3/dist/web/pusher.min.js' /* webpackIgnore: true, webpackPrefetch: true */);

      // @ts-expect-error Imported dynamically
      const socket = new Pusher(pusherKey, {
        authEndpoint: "".concat(forumAttr('apiUrl') || app.forum.attribute('apiUrl'), "/pusher/auth"),
        cluster: forumAttr('pusherCluster'),
        wsHost: forumAttr('pusherHost'),
        wsPort: forumAttr('pusherPort'),
        wssPort: forumAttr('pusherPort'),
        forceTLS: forumAttr('pusherUseTLS'),
        encrypted: forumAttr('pusherEncrypted'),
        disableStats: true,
        enabledTransports: ['ws', 'wss'],
        auth: {
          headers: {
            'X-CSRF-Token': ((_app$session = app.session) == null ? void 0 : _app$session.csrfToken) || ((_app$data2 = app.data) == null || (_app$data2 = _app$data2.session) == null ? void 0 : _app$data2.csrfToken)
          }
        }
      });
      const sessionUserId = ((_app$data3 = app.data) == null || (_app$data3 = _app$data3.session) == null ? void 0 : _app$data3.userId) || ((_app$session2 = app.session) == null || (_app$session2 = _app$session2.user) == null ? void 0 : _app$session2.id());
      const userChannel = sessionUserId ? socket.subscribe("private-user".concat(sessionUserId)) : null;
      return {
        channels: {
          main: socket.subscribe('public'),
          user: userChannel
        },
        pusher: socket
      };
    } catch (e) {
      console.warn('[flarum-pusher] Disabled: unable to load Pusher library or initialize connection', e);
      return {
        channels: {
          main: {
            bind: () => {},
            unbind: () => {}
          },
          user: null
        },
        pusher: {
          bind: () => {},
          unbind: () => {}
        }
      };
    }
  })();
  app.pushedUpdates = [];
  let discussionListHandler = null;
  extend(DiscussionList.prototype, 'oncreate', function () {
    app.pusher.then(binding => {
      if (!binding) return;
      const pusher = binding.pusher;
      if (discussionListHandler) {
        pusher.unbind('newPost', discussionListHandler);
      }
      discussionListHandler = data => {
        const params = app.discussions.getParams();
        const hasFilter = params.filter && Object.keys(params.filter).length > 0;
        if (!params.q && !params.sort && !hasFilter) {
          if (params.tags) {
            const tag = app.store.getBy('tags', 'slug', params.tags);
            const tagId = tag == null ? void 0 : tag.id();
            if (!tagId || !data.tagIds || !data.tagIds.map(String).includes(tagId)) return;
          }
          const id = String(data.discussionId);
          if ((!app.current.get('discussion') || id !== app.current.get('discussion').id()) && app.pushedUpdates.indexOf(id) === -1) {
            app.pushedUpdates.push(id);
            if (app.current.matches(IndexPage)) {
              app.setTitleCount(app.pushedUpdates.length);
            }
            m.redraw();
          }
        }
      };
      pusher.bind('newPost', discussionListHandler);
    }).catch(() => {});
  });
  extend(DiscussionList.prototype, 'onremove', function () {
    app.pusher.then(binding => {
      if (!binding || !discussionListHandler) return;
      binding.pusher.unbind('newPost', discussionListHandler);
      discussionListHandler = null;
    }).catch(() => {});
  });
  extend(DiscussionList.prototype, 'view', function (vdom) {
    if (app.pushedUpdates) {
      const count = app.pushedUpdates.length;
      if (count && typeof vdom === 'object' && vdom) {
        if (!Array.isArray(vdom.children)) {
          vdom.children = vdom.children ? [vdom.children] : [];
        }
        vdom.children.unshift(m(Button, {
          className: "Button Button--block DiscussionList-update",
          onclick: () => {
            this.attrs.state.refresh().then(() => {
              this.loadingUpdated = false;
              app.pushedUpdates = [];
              app.setTitleCount(0);
              m.redraw();
            });
            this.loadingUpdated = true;
          },
          loading: this.loadingUpdated
        }, app.translator.trans('flarum-pusher.forum.discussion_list.show_updates_text', {
          count
        })));
      }
    }
  });
  extend(DiscussionPage.prototype, 'oncreate', function () {
    app.pusher.then(binding => {
      if (!binding) return;
      const pusher = binding.pusher;
      if (this.pusherNewPostHandler) {
        pusher.unbind('newPost', this.pusherNewPostHandler);
      }
      this.pusherNewPostHandler = data => {
        var _this$discussion;
        const id = String(data.discussionId);
        const discussionId = (_this$discussion = this.discussion) == null ? void 0 : _this$discussion.id();
        if (this.discussion && discussionId === id && this.stream) {
          var _this$discussion$comm;
          const oldCount = (_this$discussion$comm = this.discussion.commentCount()) != null ? _this$discussion$comm : 0;
          app.store.find('discussions', discussionId).then(() => {
            var _this$stream;
            (_this$stream = this.stream) == null || _this$stream.update().then(m.redraw);
            if (!document.hasFocus()) {
              var _this$discussion$comm2, _this$discussion2;
              app.setTitleCount(Math.max(0, ((_this$discussion$comm2 = (_this$discussion2 = this.discussion) == null ? void 0 : _this$discussion2.commentCount()) != null ? _this$discussion$comm2 : 0) - oldCount));
              window.addEventListener('focus', () => app.setTitleCount(0), {
                once: true
              });
            }
          });
        }
      };
      pusher.bind('newPost', this.pusherNewPostHandler);
    }).catch(() => {});
  });
  extend(DiscussionPage.prototype, 'onremove', function () {
    app.pusher.then(binding => {
      if (!binding || !this.pusherNewPostHandler) return;
      binding.pusher.unbind('newPost', this.pusherNewPostHandler);
      this.pusherNewPostHandler = null;
    }).catch(() => {});
  });
  extend(IndexPage.prototype, 'actionItems', items => {
    items.remove('refresh');
  });
  app.pusher.then(binding => {
    if (!binding) return;
    const channels = binding.channels;
    if (channels.user) {
      channels.user.bind('notification', () => {
        if (app.session.user) {
          var _app$session$user$unr, _app$session$user$new;
          app.session.user.pushAttributes({
            unreadNotificationCount: ((_app$session$user$unr = app.session.user.unreadNotificationCount()) != null ? _app$session$user$unr : 0) + 1,
            newNotificationCount: ((_app$session$user$new = app.session.user.newNotificationCount()) != null ? _app$session$user$new : 0) + 1
          });
        }
        m.redraw();
      });
    }
  }).catch(() => {});
});